// extracted by mini-css-extract-plugin
export var imageFix = "ImageWrapper-module--image-fix--bc52a";